import { deleteRequest, getRequest, postRequest, updateRequest } from "./http";

export const http = {
  get: getRequest,
  post: postRequest,
  put: updateRequest,
  delete: deleteRequest,
};
